



































import { Component, Prop } from 'vue-property-decorator';

import { BusinessOnboardingAccountForm } from '@/models/business-onboarding';

import SignupService from '@/api/SingupService';
import CoinSetupService from '@/api/CoinSetupService';
import InternationalizationService from '@/api/InternationalizationService';

import TextField from '@/components/atoms/TextField/TextField.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import AccountForm, {
  AccountFormData
} from '@/componentsV2/templates/AccountForm/V2/AccountForm.vue';
import ProviderButton from '@/components/molecules/ProviderButton/ProviderButton.vue';

import { BUSINESS_ONBOARDING_UUID_CREATION } from '@/store/modules/businessOnboarding';

import { getOauthState } from '@/router/router-utils';
import segmentIo from '@/utils/segment.io';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import APIService from '@/api';
import BusinessOnboardingModel from '../../../BusinessOnboardingModel.vue';
import eventBus from '@/utils/eventBus';

@Component({
  components: {
    FilledButton,
    TextField,
    AccountForm,
    ProviderButton
  }
})
export default class YourAccountComplete extends BusinessOnboardingModel {
  @Prop() backUrl!: string;
  @Prop() onNext!: () => void;

  signUpService = new SignupService();
  coinSetupService = new CoinSetupService();
  internationalizationService = new InternationalizationService();

  oauthState = getOauthState();

  loading = false;
  defaultFormData: BusinessOnboardingAccountForm = this.$store.getters[
    'businessOnboarding/getAccountFormData'
  ];

  get uuid() {
    return localStorage.getItem(BUSINESS_ONBOARDING_UUID_CREATION) || '';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  updateUserData(form: AccountFormData) {
    this.$store.dispatch('businessOnboarding/SET_ACCOUNT_FORM', {
      ...form,
      password: ''
    });
  }

  back() {
    this.$router.replace(this.backUrl);
  }

  mounted() {
    setFocusOnFirstInput();
  }

  onClick() {
    eventBus.$emit('accountFormSubmit');
  }

  async handleSubmit(formData: AccountFormData) {
    const { firstName, lastName, email, password, recaptcha } = formData;

    this.loading = true;

    const manager = {
      fullname: `${firstName} ${lastName}`,
      mail: email,
      password
    };

    try {
      if (!APIService.token) {
        const {
          response,
          status,
          data
        } = (await this.signUpService.createManager(
          {
            manager,
            anonymousId: segmentIo.getAnonymousId()
          },
          recaptcha
        )) as any;

        let statusRequest = status ? status : response.status;

        if (statusRequest !== 200) {
          const message =
            statusRequest === 400
              ? 'Email is already registered'
              : response.data.message;

          this.loading = false;
          this.$notification(message, 'error');
          return;
        }

        this.signUpService.setCredentials(data.access_token);
        this.$store.dispatch('businessOnboarding/SET_ACCOUNT_FORM', formData);

        if (this.uuid) await this.coinSetupService.identifyUser(this.uuid);
      }
      if (!this.businessInfo) await this.onCreateBusiness();

      if (this.onNext) {
        this.loading = true;
        await this.onNext();
      }
    } finally {
      this.loading = false;
    }
  }
}
